<template>
  <div id="dashboard" style="min-height: 650px;">
    <div id="dashboard" class="content">
      <div class="block block-rounded block-bordered">
        <div class="block-header block-header-default">
          <h3 class="block-title">{{edit=='add'?'新增项目合同':'项目合同详情'}}</h3>
        </div>
        <div class="block-content">
          <form action="be_forms_elements.html" method="POST" enctype="multipart/form-data" onsubmit="return false;">
            <h2 class="content-heading pt-0 font-w600">
              基本信息
              <span class="input-required" v-show="edit=='add'">*</span>
            </h2>
            <div class="row push">
              <div class="col-lg-4">请先简历合作方信息，在填写合同基本信息</div>
              <div class="col-lg-8 col-xl-5">
                <div class="form-group">
                  <div class="form-group">
                    <label for="example-text-input">合同编号</label>
                    <input type="text" class="form-control form-control-inline col-12 mt-2" placeholder="请输入编号"
                      v-model="form.contractCode" maxlength="16" />
                  </div>
                  <div class="form-group">
                    <label for="example-text-input">合作方名称</label>
                    <div class="pb-2" v-for="(i,k) in form.bankInfo" :key="k">
                      <el-select v-model="i.unId" filterable placeholder="请选择" style="width: 100%;"
                        :disabled="edit!='add'" @change="selectCooperator(i, k)">
                        <!-- <el-option label="请选择" value disabled></el-option> -->
                        <el-option v-for="item in searchCooperatorList" :key="item.unId" :label="item.name"
                          :value="item.unId"></el-option>
                      </el-select>
                      <button type="button" @click="delCooperator(k)" class="btn-block-option" style="position: absolute;line-height: 1.5">
                        <i class="si si-close"></i>
                      </button>
                    </div>
                  </div>
                  <div class="form-group text-right">
                    <a href="javascript:void(0)" @click="addCooperator()">+新增</a>
                  </div>
                  <div class="form-group inline-block" style="width:48%;margin-right:4%">
                    <label for="example-text-input">
                      合同签订日期
                      <span class="input-required">*</span>
                    </label>
                    <input type="text" class="js-flatpickr form-control bg-white-ab" style="background-color:#fff"
                      v-model="form.signingTime" />
                  </div>
                  <div class="form-group inline-block" style="width:48%;">
                    <label for="example-text-input">
                      合同终止日期
                      <span class="input-required" v-show="edit=='add'">*</span>
                    </label>
                    <input type="text" class="js-flatpickr form-control bg-white-ab" style="background-color:#fff"
                      v-model="form.stopSigningTime" />
                  </div>
                  <div class="form-group">
                    <label for="example-text-input">
                      备注
                      <span class="input-required" v-show="edit=='add'">*</span>
                    </label>
                    <input class="form-control" placeholder maxlength="30" v-model="form.remarks" />
                  </div>
                  <div class="form-group">
                    <label class="col-sm-12 control-label">附件</label>
                    <div class="row pl-4">
                      <div class="options-container col-4 inline-block pb-4 pr-0 pl-0"
                        v-for="(item,index) in form.annexList" :key="index" v-if="form.annexList.length > 0">
                        <div class="options-item block block-rounded block-transparent mb-0">
                          <div class="block-content text-center">
                            <p class="mb-2 overflow-hidden">
                              <i class="fa fa-fw fa-3x far fa-copy"></i>
                            </p>
                            <p class="font-w600 mb-0"
                              style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{item.filename}}
                            </p>
                          </div>
                        </div>
                        <div class="options-overlay rounded-lg bg-white-50">
                          <div class="options-overlay-content">
                            <div class="mb-3">
                              <a class="btn btn-hero-light" :href="item.url" target="blank">
                                <i class="fa fa-eye text-primary mr-1"></i> 查看
                              </a>
                            </div>
                            <div class="btn-group">
                              <a class="btn btn-sm btn-light"
                                :href="`${operateURL}/code/downloadPdf?downLoadPath=${item.url}`"
                                :download="item.filename" target="blank">
                                <i class="fa fa-download text-black mr-1"></i>
                              </a>
                              <a class="btn btn-sm btn-light" href="javascript:void(0)" @click="delFile(index)">
                                <i class="fa fa-trash text-danger mr-1"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <el-upload class="avatar-uploader dz-image-120 inline-block" :action="actionUrl"
                        :headers="headers" :show-file-list="false" :on-success="handlePreview">
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <h2 class="content-heading pt-0 font-w600">
              结算信息
              <span class="input-required" v-show="edit=='add'">*</span>
            </h2>
            <div class="row push noborder">
              <div class="col-md-6" v-for="(cooperator,index) in form.bankInfo" :key="index">
                <div class="block block-rounded block-bordered">
                  <div class="block-header block-header-default">
                    <h3 class="block-title">{{cooperator.name}}</h3>
                  </div>
                  <div class="block-content">
                    <div class="form-group">
                      <label for="example-text-input">户名</label>
                      <input type="text" class="form-control form-control-inline col-12 mt-2" placeholder="请输入户名"
                        :disabled="cooperator.unId == ''" v-model="cooperator.bankAccountHolder" maxlength="16" />
                    </div>
                    <div class="form-group">
                      <label for="example-text-input">账号</label>
                      <div>
                        <input class="form-control" :disabled="cooperator.unId == ''" placeholder="请输入账号" maxlength="30"
                          v-model="cooperator.bankAccount" />
                      </div>
                    </div>
                    <div class="form-group inline-block" style="width:48%;margin-right:4%">
                      <label for="example-text-input">
                        省/直辖市
                        <span class="input-required">*</span>
                      </label>
                      <el-select filterable :disabled="cooperator.unId == ''" placeholder="请输入" style="width: 100%;"
                        v-model="cooperator.pro" @change="getBankList(index)">
                        <el-option v-for="item in provinceList" :key="item.PROVICE" :label="item.PROVICE"
                          :value="item.PROVICE"></el-option>
                      </el-select>
                    </div>
                    <div class="form-group inline-block" style="width:48%;">
                      <label for="example-text-input">
                        市/县
                        <span class="input-required" v-show="edit=='add'">*</span>
                      </label>
                      <el-select filterable :disabled="cooperator.unId == ''" placeholder="请输入" style="width: 100%;"
                        v-model="cooperator.city" @change="getBankList(index)">
                        <el-option v-for="item in cityList" :key="item.CITY" :label="item.CITY" :value="item.CITY">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="form-group">
                      <label for="example-text-input">开户银行</label>
                      <el-select filterable :disabled="cooperator.unId == ''" placeholder="请输入" style="width: 100%;"
                        v-model=" cooperator.bankName " @change="changeBankName(index)">
                        <el-option v-for="item in bankDistrictList" :key="item.BANK_NAME" :label="item.BANK_NAME"
                          :value="item.BANK_NAME"></el-option>
                      </el-select>
                    </div>
                    <div class="form-group">
                      <label for="example-text-input">开户支行</label>
                      <el-select filterable :disabled="cooperator.unId == ''" placeholder="请输入" style="width: 100%;"
                        v-model=" cooperator.bankNumber" @change="changeBankNum()">
                        <el-option v-for="item in bankNoList" :key="item.LINE_NUMBER" :label="item.BANK_BRANCH"
                          :value="item.LINE_NUMBER"></el-option>
                      </el-select>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4"></div>
              <div class="col-lg-8 col-xl-4">
                <div class="form-group inline-block" style="width:100%;">
                  <button v-if="editBtn" style="width:100%;" type="button" class="btn btn-sm btn-primary"
                    @click="submit()">保存</button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <!-- END Page Content -->
      </div>
    </div>
  </div>
</template>

<script>
  import Util from "../../../Util.js";

  export default {
    name: "index",
    data() {
      return {
        form: {
          contractCode: "",
          bankInfo: [{
            unId: '',
            name: '',
            bankAccountHolder: '',
            bankAccount: '',
            bankName: '',
            bankNumber: '',
            pro: '',
            city: ''
          }],
          signingTime: "",
          stopSigningTime: "",
          remarks: "",
          annexList: []
        },
        searchCooperatorList: [{
            unId: 'dWaeaVuoBgKEEj5cH0Yr4kcZyPuGjV',
            name: '求其啦',
            bankAccountHolder: '',
            bankAccount: '',
            bankName: '',
            bankNumber: '',
            pro: '',
            city: ''
          },
          {
            unId: '5hqtGQKgHQEJQyiZsXO64CA3Y5BXlp',
            name: '林煌',
            bankAccountHolder: '',
            bankAccount: '',
            bankName: '',
            bankNumber: '',
            pro: '',
            city: ''
          },
          {
            unId: 'qweqweqwe',
            name: 'XXX合作方333333',
            bankAccountHolder: '',
            bankAccount: '',
            bankName: '',
            bankNumber: '',
            pro: '',
            city: ''
          }
        ],
        bankNoList: [],
        bankDistrictList: [],
        provinceList: [],
        cityList: [],
        actionUrl: Util.operateURL + "/picture/pictureUpload",
        headers: {
          Accept: "application/json, text/plain, */*",
          token_key: Util.getCookie("token_key")
        },
        edit: "",
        operateURL: Util.operateURL,
        editBtn: Util.isHavePerm("rateManagement/addChargeRateApply") ||
          Util.isHavePerm("rateManagement/updateChargeRateApply") ||
          Util.isHavePerm("rateManagement/addRate") ||
          Util.isHavePerm("rateManagement/updateRate")
      };
    },
    computed: {
      duration() {
        return this.$store.state.duration;
      },
      params() {
        return this.$store.state.params;
      }
    },
    watch: {},
    mounted() {
      this.edit = this.$route.params.id;
      setTimeout(() => {
        Dashmix.helpers(["flatpickr", "datepicker"]);
      }, 1000);
      this.getBankList();
    },
    methods: {
      // 删除附件
      delFile(key) {
        this.form.annexList.splice(key, 1);
      },
      // 删除合作方
      delCooperator(key) {
        if (this.form.bankInfo.length <= 1) {
          Util.message("err", '最少添加1个合作方');
          return
        }
        this.form.bankInfo.splice(key, 1);
      },
      changeBankNum() {
        // element强制刷新
        this.$forceUpdate();
      },
      changeBankName(index) {
        this.$forceUpdate();
        this.getbankNoList(index);
      },
      // 新增合作方
      addCooperator() {
        if (this.form.bankInfo.length >= 3) {
          Util.message("err", '最多只能添加3个合作方');
        } else {
          this.form.bankInfo.push({})
        }
      },
      // 选择合作方
      selectCooperator(value, key) {
        this.searchCooperatorList.find(item => {
          for (let i in this.form.bankInfo) {
            if (item.unId == this.form.bankInfo[i].unId && item.unId == value.unId) {
              console.log(item)
              if (this.form.bankInfo.includes(item)) {
                this.form.bankInfo[key] = {}
                Util.message("err", '请勿重复添加合作方');
                return
              } else {
                this.form.bankInfo[i] = item
                this.$forceUpdate();
              }
            }
          }
        })
      },
      // 附件上传成功回调
      handlePreview(res) {
        if (res.code == 200) {
          this.form.annexList.push(res.data);
          Util.message("succ", "上传成功");
        } else if (res.code === 4412) {
          Util.message("err", res.desc);
        } else {
          Util.message("err", res.desc);
        }
      },
      getBankList(index, formdata) {
        let d;
        if (typeof index != 'undefined') {
          if (this.form.bankInfo[index].pro && this.form.bankInfo[index].city == '') {
            d = {
              province: this.form.bankInfo[index].pro
            };
          }
          if (this.form.bankInfo[index].city) {
            d = {
              province: this.form.bankInfo[index].pro,
              city: this.form.bankInfo[index].city
            };
          }
        }

        this.$http
          .post(`${Util.searchURL}/User/ListByBankDistrict/?key=`, d)
          .then(
            res => {
              if (res.data.code === 200) {
                this.provinceList = res.data.data.PROVICE;
                if (typeof index != 'undefined' && this.form.bankInfo[index].pro && !this.form.bankInfo[index].city) {
                  this.cityList = res.data.data.CITY;
                  this.form.bankInfo[index].city = "";
                  this.form.bankInfo[index].bankName = "";
                  this.form.bankInfo[index].bankNumber = "";
                }
                this.bankDistrictList = res.data.data.BANK;

                if (typeof index != 'undefined' && this.form.bankInfo[index].city) {
                  this.cityList = res.data.data.CITY;
                  this.form.bankInfo[index].bankName = "";
                  this.form.bankInfo[index].bankNumber = "";
                  this.bankDistrictList = res.data.data.BANK;
                }

                // if (formdata) {
                //   this.form.bankName = formdata.BANK_NAME ?
                //     formdata.BANK_NAME :
                //     "";
                //   this.getbankNoList(formdata);
                // }
              }
            },
            err => {
              console.log(err);
            }
          );
      },
      getbankNoList(index) {
        this.$http
          .post(`${Util.searchURL}/User/ListByBankNo?key=`, {
            province: this.form.bankInfo[index].pro,
            city: this.form.bankInfo[index].city,
            bank: this.form.bankInfo[index].bankName
          })
          .then(
            res => {
              if (res.data.code === 200) {
                this.bankNoList = res.data.data;
                // if (formdata) {
                //   this.form.bankNumber = formdata.BANK_NUMBER ?
                //     formdata.BANK_NUMBER :
                //     "";
                // }
              }
            },
            err => {
              console.log(err);
            }
          );
      },
      submit() {
        let url = "";
        if (this.edit == "add") {
          url = `${Util.operateURL}/contractBase/addContractInfo`;
        } 
        this.$http.post(url, this.form).then(
          res => {
            if (res.data.code === 200) {
              Util.message("succ", res.data.desc);
            } else {
              Util.message("err", res.data.desc);
            }
          },
          err => {
            console.log(err);
          }
        );
      },

    }
  };
</script>
<style lang="less" scope>

</style>